import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { measurement } from "../../measurement";
import { op } from "../../rxjs";

@Injectable({
	providedIn: "root",
}) export class MeasurementTypeToUnit{
	public readonly system$=new BehaviorSubject<measurement.UnitSystem>('metricUnit');
	public readonly units$=this.system$
		.pipe(
			op.map(system=>{
				return Object.fromEntries(
					Object.entries(measurement.typeMeta).map(([_key, typeMeta]) => {
						const key=<measurement.Type>_key;
						return [
							key,
							typeMeta[system]
						];
						// if (system in typeMeta) {
						// 	return [
						// 		key as keyof measurement.TypeToUnit,
						// 		[system]
						// 	];
						// } else {
						// 	// Default to metricUnit or imperialUnit if the system isn't found
						// 	return [
						// 		key as keyof measurement.TypeToUnit,
						// 		system.includes('Metric') ? typeMeta.metricUnit : typeMeta.imperialUnit
						// 	];
						// }
					})
				) as measurement.TypeToUnit;
			}),
			op.shareReplay(1));

	// constructor(){
	// 	// this.system$.subscribe(system => {
	// 	// 	this.units$.next(this.getUnitsForSystem(system));
	// 	// });
	// }

	// public readonly units$=new BehaviorSubject(this.getUnitsForSystem(this.system$.value));

	// public getUnitsForSystem(system: UnitSystem): measurement.TypeToUnit {
	// }


  // new BehaviorSubject(
	// 	<measurement.TypeToUnit>Object.fromEntries(Object.entries(measurement.typeMeta).map(([key,{metricUnit}])=>[key,metricUnit]))
	// );
}
